import type { LocalePrefixMode } from 'next-intl/routing';
import { languages } from './locale';

/**
 * Locales supported by next-intl.
 * Note: These are simply language codes since they map our localized dictionaries such as en.json, fr.json, etc..
 */
export const locales = languages;

// See https://github.com/amannn/next-intl/issues/444 regarding issues with initial rendering and default locale for localePrefix = 'as-needed'
// For now, we'll use 'never' as a workaround and rely on the NEXT_LOCALE cookie to switch rendering to the correct locale.
// (see also CloudFormation configuration which uses the cookie value as part of the cache key)
export const localePrefix = 'never' satisfies LocalePrefixMode;
